import { Transform } from 'stream'
import _ from 'lodash'

/**
 * Returns a Transform that marks nodes that are pending deletion with the
 * 'is-disabled' CSS class. Also updates the pendingDeletion property for nodes
 * in the tree that are descendants of other nodes that are pendingDeletion
 * (#24141)
 * @param {Function} treeProvider returns the kalpa-tree
 * @returns {Transform}
 */
function pendingDeletionTransform(treeProvider) {
	var map = new Transform({ objectMode: true })
	map._transform = function (node, enc, next) {
		// the parent comes through the stream before the child so it's
		// safe to grab it
		let parent = node.parentId && treeProvider().get(node.parentId)
		// if the parent's pending deletion, so is the node itself
		node.pendingDeletion = node.pendingDeletion || _.get(parent, 'pendingDeletion')
		if (node.pendingDeletion) {
			markPendingDeletion(node)
		}
		this.push(node)
		next()
	}
	return map
}

/**
 * Updates the state of a node to indicate that it's pending deletion (adds
 * the 'is-disabled' class and sets pendingDeletion = true)
 * @param {Object} node the node in the tree
 */
function markPendingDeletion(node) {
	node.pendingDeletion = true
	node.className = node.className ? node.className + ' ' : ''
	node.className += 'is-disabled'
}

export default pendingDeletionTransform
export { markPendingDeletion }

pendingDeletionTransform.__filename__ = 'components/pending-deletion-transform.js'
